export default __webpack_public_path__ + "static/slack-42b9b12ec2617d46a933faa5ca9f0004.svg";